import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import compose from 'recompose/compose';
import EnhancedRaisedButton from 'components/button/EnhancedRaisedButton';
import PhoneInput from 'components/form/InputFields/MobianPhoneInput/PhoneInput';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import styled from 'styled-components';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { Section, Row, Item } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, Field, isInvalid } from 'redux-form';
import { Link } from 'react-router-dom';

const StyledLink = styled(Link)`
    padding: .5rem;
    min-width: 88px;
    color: ${ theme.palette.primary1Color };
    font-size: 1rem;
    text-decoration: none;
    text-align: center;

    &:hover,
    &:focus {
        color: ${ theme.palette.primary1ColorHover };
    }
`;

const SignUpForm = (props) => {
    const {
        handleSubmit,
        handleSubmitForm,
        invalid,
        pristine,
        submitting,
        translate,
    } = props;

    return (
        <Card style={ { width: 600 } }>
            <CardText>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <h1 style={ { textAlign: 'center' } }>{ translate('signUp.title') }</h1>

                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ submitting }
                                    label={ translate('resources.accounts.fields.email') }
                                    fullWidth={ false }
                                    name='email'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ submitting }
                                    label={ translate('signUp.fields.confirm_email') }
                                    fullWidth={ false }
                                    name='confirm-email'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ submitting }
                                    label={ translate('auth.login.fields.password') }
                                    fullWidth={ false }
                                    name='password'
                                    type='password'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ submitting }
                                    label={ translate('signUp.fields.confirm_password') }
                                    fullWidth={ false }
                                    name='confirm-password'
                                    type='password'
                                />
                            </Item>
                        </Row>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ submitting }
                                    label={ translate('filters.components.name.label') }
                                    fullWidth={ false }
                                    name='first_name'
                                />
                            </Item>

                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    disabled={ submitting }
                                    label={ translate('filters.components.lastName.label') }
                                    fullWidth={ false }
                                    name='last_name'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ PhoneInput }
                                    disabled={ submitting }
                                    label={ translate('filters.components.phone.label') }
                                    fullWidth={ true }
                                    name='phone'
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <StyledLink to='/login'>
                                { translate('actions.cancel') }
                            </StyledLink>

                            <EnhancedRaisedButton
                                disabled={ pristine || submitting || invalid }
                                label={ translate('signUp.title') }
                                loading={ submitting }
                                primary={ true }
                                type='submit'
                            />
                        </Row>

                    </Section>
                </form>
            </CardText>
        </Card>
    );
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.email) {
                errors.email = translate('forms.required');
            }

            if (!values.password) {
                errors.password = translate('forms.required');
            }

            if (!values.phone) {
                errors.phone = translate('forms.required');
            }

            if (values.password && values.password.length < 6) {
                errors.password = translate('signUp.errors.passowrd_chars');
            }

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            if (!values['last-name']) {
                errors['last-name'] = translate('forms.required');
            }

            if (!values['confirm-email']) {
                errors['confirm-email'] = translate('forms.required');
            }

            if (!values['confirm-password']) {
                errors['confirm-password'] = translate('forms.required');
            }

            if (values.email !== values['confirm-email']) {
                errors['confirm-email'] = translate('signUp.errors.same_email');
            }

            if (values.password !== values['confirm-password']) {
                errors['confirm-password'] = translate('signUp.errors.same_password');
            }

            return errors;
        },
    }),
);

SignUpForm.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default enhance(SignUpForm);



// WEBPACK FOOTER //
// ./src/pages/signUp/SignUpForm.js